"use strict";

import Panorama from './three/panorama';
import Top from './main/top';
import Browser from './util/browser';

if(Browser.isiPad){
	Browser.setViewportiPad();
}

window.onload = function(){
	new App();
}

class App{
	constructor(){
		this.top = new Top();
		this.top.on('init1' , ()=>{
			setTimeout(this.init2.bind(this), 100);
		})
		this.top.init();
		
		//ローディングが上手くいかないときの念のため
		setTimeout(()=>{
			if( $('#BodyContents').hasClass('hide') ){
				this.init3();
			}
		}, 10000);
	}
	
	init2(){
		this.top.on('init2' , ()=>{
			setTimeout(this.init3.bind(this), 100);
		})
		this.top.init2();
	}
	
	init3(){
		if( !$('#BodyContents').hasClass('hide') ) return;
		$('#BodyContents').removeClass('hide');
		$('#Loading').velocity('stop').velocity({opacity:0},{duration:750,delay:100,display:'none'
			,complete:()=>{
				this.top.start();
			}
		})
	}
}


// WEBPACK FOOTER //
// ./js/app.js